import { ContentShareQuotaFullDTO } from 'src/app/services/api/api';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'sb-comp-single-quota',
  templateUrl: './single-quota.component.html',
  styleUrls: ['./single-quota.component.scss'],
  standalone: false,
})
export class SingleQuotaComponent {
  @Input({ required: true }) quota!: ContentShareQuotaFullDTO;
  @Input({ required: true }) width!: number;
}
